export default __webpack_public_path__ + "static/media/project_construction_on.d6530c0e.svg";